import { styled, theme } from '../../lib/stitches'

export const StyledMessage = styled('div', {
  borderRadius: theme.sizes.ui_04,
  padding: theme.sizes.ui_12,
  fontSize: 13,
  lineHeight: 1.5,

  variants: {
    variant: {
      ERROR: {
        color: theme.colors.ui_red,
        border: `1px solid ${theme.colors.ui_red_light}`,
        backgroundColor: theme.colors.ui_red_lightest
      },
      WARNING: {
        color: theme.colors.ui_orange,
        border: `1px solid ${theme.colors.ui_orange_light}`,
        backgroundColor: theme.colors.ui_orange_lightest
      },
      INFO: {
        color: theme.colors.ui_blue,
        border: `1px solid ${theme.colors.ui_blue_light}`,
        backgroundColor: theme.colors.ui_blue_lightest
      },
      SUCCESS: {
        color: theme.colors.ui_green,
        border: `1px solid ${theme.colors.ui_green_light}`,
        backgroundColor: theme.colors.ui_green_lightest
      }
    }
  }
})
